export class ContactModel {
  public webform_id = 'freida_contact_request';
  public user_type: string;
  public nature_of_inquiry: string;
  public email: string;
  public program_id: string;
  public phone: {
    phone: string,
    ext: string,
    type: string
  };
  public message = '';
  public name: {
    first: string,
    last: string
  };

  constructor(values?: Partial<ContactModel>) {
    Object.assign(this, values);
    this.name = {
      first: '',
      last: ''
    };

    this.phone = {
      phone: '',
      ext: '0',
      type: null
    };
  }
}
